import React from "react";
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
// core components


const useStyles = makeStyles(theme => ({
  modalBottom: {
    justifyContent: "center",

    '& button': {
      margin: theme.spacing(1),
    },
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide ref={ref} {...props} />;
});

export default function CustomInput(props) {
  const classes = useStyles();
  const {
    open,
    onClose,
    dialogTitle,
    dialogContent,
    dialogActions,
    dialogProps,
  } = props;

  return (
    <Dialog
      fullWidth={true}
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      aria-labelledby="form-dialog-title"
      {...dialogProps}
    >
      <DialogTitle id="form-dialog-title">{dialogTitle}</DialogTitle>
      <DialogContent>
        {dialogContent}
      </DialogContent>
      <DialogActions className={classes.modalBottom}>
        {dialogActions}
      </DialogActions>
    </Dialog>
  );
}
